
const host_state = true    //true为正式，false为测试

// 测试接口
let host = 'http://cq2com-dev-admin.52shanglu.com';

if(host_state){
    // 正式接口
    host = 'https://cq2-common.waakuu.com';
}

export default {
    host,
    host_state
}